import Container from 'saur_ui_library/src/Atoms/Container/Container';
import SwitchComponent from '../../../components/common/component/SwitchComponent';
import {
  FishFarmingCat,
  LinearInterface,
  ShellfishInterface,
  YesNoInterface,
} from '../../Interface';
import RadioListComponent from '../../../components/common/component/RadioListComponent';
import React from 'react';
import { UsageRatingApi } from '../../api';

// Function to rendring Beach form
export const ShowBeachForm = ({
  form,
  setForm,
  setGrayedBeach,
  grayedBeach,
}) => {
  return (
    <Container automatedTestId='beach-form' className='card-data'>
      <SwitchComponent
        className='beach-switch'
        title='Existe t’il une plage proche ?'
        checked={form?.nearbyBeach}
        id='beach-switch'
        onChange={(v: any) => {
          setForm((oldValues) => {
            setGrayedBeach(!form?.nearbyBeach);
            return { ...oldValues, nearbyBeach: v.value };
          });
        }}
      />
      <Container className={`${!grayedBeach && 'grayed-out'}`}>
        <RadioListComponent
          className='radio-list'
          wordClassName='word-className'
          value='Longueur de la plage en ml'
          selected={form?.beachLengthCode}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, beachLengthCode: v.checked };
            });
          }}
          values={LinearInterface}
        />
        <RadioListComponent
          className='radio-list'
          wordClassName='word-className'
          selected={form?.beachSupervised ? 1 : 0}
          value='Plage surveillée'
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, beachSupervised: v.checked };
            });
          }}
          values={YesNoInterface}
        />
      </Container>
    </Container>
  );
};

// Function to rendring Activity form
export const ShowActivityForm = ({
  form,
  setForm,
  setGrayedActivity,
  grayedActivity,
  coastline,
}) => {
  return (
    <Container className='card-data'>
      <Container className={`${coastline && 'grayed-out'}`}>
        <SwitchComponent
          className='activity-switch'
          title='Existe t’il des activités conchylicoles ou ostréicoles ?'
          checked={form?.nearbyShellfishArea}
          id='activity-switch'
          onChange={(v: any) => {
            setForm((oldValues) => {
              setGrayedActivity(!form.nearbyShellfishArea);
              return { ...oldValues, nearbyShellfishArea: v.value };
            });
          }}
        />
      </Container>

      <Container
        className={`${!grayedActivity && 'grayed-out'}`}
        automatedTestId='activity-form'
      >
        <RadioListComponent
          wordClassName='word-className'
          className='radio-list'
          value='Surface du parc en m2'
          selected={form?.shellfishAreaSurfaceCode}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, shellfishAreaSurfaceCode: v.checked };
            });
          }}
          values={ShellfishInterface}
        />
      </Container>
      <Container>
        <RadioListComponent
          className='radio-list'
          value='Zone de pêche (pêche à pied, pisciculture …)'
          selected={form?.nearbyFishingArea ? 1 : 0}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, nearbyFishingArea: v.checked };
            });
          }}
          values={YesNoInterface}
        />
        <RadioListComponent
          className='radio-list'
          value='Marais salant'
          selected={form?.nearbySaltMarsh ? 1 : 0}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, nearbySaltMarsh: v.checked };
            });
          }}
          values={YesNoInterface}
        />
        <RadioListComponent
          className='radio-list'
          value='Mouillage'
          selected={form?.nearbyMooring ? 1 : 0}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, nearbyMooring: v.checked };
            });
          }}
          values={YesNoInterface}
        />
        <Container className={`${coastline && 'grayed-out'}`}>
          <RadioListComponent
            className='radio-list'
            value='Centre d’activités ou d’eaux vives à proximité'
            selected={form?.nearbyWaterActivitiesCenter ? 1 : 0}
            onChange={(v: any) => {
              setForm((oldValues) => {
                return { ...oldValues, nearbyWaterActivitiesCenter: v.checked };
              });
            }}
            values={YesNoInterface}
          />
          <RadioListComponent
            className='radio-list'
            value='Zone de captage d’eau potable à proximité'
            selected={form?.nearbyDrinkingWaterCatchmentArea ? 1 : 0}
            onChange={(v: any) => {
              setForm((oldValues) => {
                return {
                  ...oldValues,
                  nearbyDrinkingWaterCatchmentArea: v.checked,
                };
              });
            }}
            values={YesNoInterface}
          />
          <RadioListComponent
            className='radio-list'
            value='Catégorie piscicole (eau douce)'
            selected={form?.fishCategoryCode}
            onChange={(v: any) => {
              setForm((oldValues) => {
                return { ...oldValues, fishCategoryCode: v.checked };
              });
            }}
            values={FishFarmingCat}
          />
        </Container>
      </Container>
    </Container>
  );
};

export const updateUsageRating = async ( setRating,newDataList,code) => {
  newDataList.nearbyShellfishArea = false;
  newDataList.nearbyWaterActivitiesCenter = false;
  newDataList.nearbyDrinkingWaterCatchmentArea = false;
  newDataList.fishCategoryCode = 3;
  newDataList.shellfishAreaSurfaceCode = 1;
  try {
    const rating = await UsageRatingApi.updateUsageRating(
      {
        ...newDataList,
        nearbyWaterActivitiesCenter: false,
        nearbyDrinkingWaterCatchmentArea: false,
      },
      code,
    );  
    setRating(rating?.data.rating);
  } catch (error) {
    console.error('Error updating usage rating:', error);
  }
}